import { FC, useEffect } from 'react';
import { LandscapeProjectsTemplate } from '../../templates';
import { AppDispatch, RootState } from '../../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  deleteProject,
  fetchProjectsByLandscapeId,
} from '../../../store/landscapeAPI/project/reducers/project.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import styles from './LandscapeProjectsEditPage.module.css';
import cn from 'classnames';

interface LandscapeProjectsEditPageProps {}

const LandscapeProjectsEditPage: FC<LandscapeProjectsEditPageProps> = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { id: landscapeId } = useParams();

  const { projects, status } = useSelector(
    (state: RootState) => state.projectSlice
  );

  useEffect(() => {
    if (landscapeId) {
      dispatch(fetchProjectsByLandscapeId(landscapeId));
    }
  }, [dispatch, landscapeId]);

  const handleDeleteProject = async (id: string) => {
    if (landscapeId) {
      await dispatch(deleteProject({ id, compactId: landscapeId }));
      dispatch(fetchProjectsByLandscapeId(landscapeId));
    }
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <LandscapeProjectsTemplate
        projects={projects ?? []}
        handleDeleteProject={handleDeleteProject}
      />
    </div>
  );
};

export default LandscapeProjectsEditPage;
